import api from './api';

export interface AcronimoPacote {
  id: string;
  sigla: string;
  disciplinaId: string;
  tipoId: string;
  acronimoId: string;
  // projetos: Projeto[];
}

export interface AcronimoPlanilha {
  projetoId: string;
  revisao: number;
  numero: number;
  nome: string;
  id: string;
  numberIndex: number;
  dataAprovacao: string;
}

export const getAllAcronimosPacote = () => api.get<AcronimoPacote[]>(`acronimospacote`);
export const createAcronimoPacote = (acronimo: AcronimoPacote) => api.post<AcronimoPacote>(`acronimospacote`, acronimo);

export const updateAcronimoPacote = (acronimo: AcronimoPacote) => {  
  return api
    .put<boolean>(`acronimospacote/${acronimo.id}`, acronimo)
    .then(result => true)
    .catch(err => false);
};

export const deleteAcronimoPacote = (id: string) => api.delete(`acronimospacote/${id}`);
